export enum FocusModeActions {
  FOCUS_MODE_SET = 'FOCUS_MODE_SET',
  FOCUS_MODE_ENABLED_SET = 'FOCUS_MODE_ENABLED_SET',
}

export function focusModeSet({ showFocusMode, manual }: { showFocusMode: boolean; manual?: boolean }) {
  return {
    type: FocusModeActions.FOCUS_MODE_SET,
    payload: { showFocusMode, manual: showFocusMode && !!manual },
  }
}

export function setFocusModeEnabled({ enableFocusMode }: { enableFocusMode: boolean }) {
  return {
    type: FocusModeActions.FOCUS_MODE_ENABLED_SET,
    payload: { enableFocusMode },
  }
}
